export const upperCaseFirstLetterOnString = (incomingString) => {
    if (typeof incomingString !== 'string') {
        throw new Error('Provided invalid type of parameter for incomingString');
    };

    const stringArray = incomingString.split('');
    const mappedArray = stringArray.map((letter, index) => index === 0 ? letter.toUpperCase() : letter);

    const finalString = mappedArray.join``;

    return finalString;
};